(function () {
  'use strict';
  function init(root) {
    if (root.dataset.igReady) return;
    root.dataset.igReady = 'true';
    var track = root.querySelector('[data-ig-track]');
    var photos = Array.from(root.querySelectorAll('[data-ig-photo]'));
    var dialog = root.querySelector('[data-ig-dialog]');
    var nav = root.querySelector('[data-ig-navigation]');
    var index = 0;
    var trigger = null;
    var previousOverflow = '';
    function updateNavigation() {
      var overflow = track.scrollWidth - track.clientWidth;
      nav.hidden = overflow <= 2;
      root.querySelector('[data-ig-scroll="-1"]').disabled = track.scrollLeft <= 2;
      root.querySelector('[data-ig-scroll="1"]').disabled = track.scrollLeft >= overflow - 2;
    }
    root.querySelectorAll('[data-ig-scroll]').forEach(function (button) {
      button.addEventListener('click', function () {
        var width = photos[0].getBoundingClientRect().width + 12;
        track.scrollBy({left: Number(button.dataset.igScroll) * width, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      });
    });
    track.addEventListener('scroll', updateNavigation, {passive: true});
    var observer = typeof ResizeObserver === 'function' ? new ResizeObserver(updateNavigation) : null;
    if (observer) observer.observe(track);
    else window.addEventListener('resize', updateNavigation);
    updateNavigation();
    if (typeof dialog.showModal !== 'function') return;
    function display(next) {
      index = (next + photos.length) % photos.length;
      var photo = photos[index];
      var full = dialog.querySelector('[data-ig-full]');
      var thumbnail = photo.querySelector('img');
      full.src = photo.querySelector('[data-ig-enlarge]').href;
      full.alt = thumbnail.alt;
      full.width = thumbnail.width;
      full.height = thumbnail.height;
      dialog.querySelector('[data-ig-full-source]').href = photo.querySelector('[data-ig-source]').href;
      dialog.querySelector('[data-ig-counter]').textContent = (index + 1) + ' / ' + photos.length;
      dialog.querySelectorAll('[data-ig-step]').forEach(function (button) { button.hidden = photos.length < 2; });
    }
    photos.forEach(function (photo, position) {
      var link = photo.querySelector('[data-ig-enlarge]');
      link.setAttribute('aria-haspopup', 'dialog');
      link.addEventListener('click', function (event) {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        trigger = link;
        display(position);
        previousOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        dialog.showModal();
      });
    });
    dialog.querySelector('[data-ig-close]').addEventListener('click', function () { dialog.close(); });
    dialog.querySelectorAll('[data-ig-step]').forEach(function (button) {
      button.addEventListener('click', function () { display(index + Number(button.dataset.igStep)); });
    });
    dialog.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
        display(index + (event.key === 'ArrowRight' ? 1 : -1));
      }
    });
    dialog.addEventListener('click', function (event) {
      var bounds = dialog.getBoundingClientRect();
      if (event.target === dialog && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom)) dialog.close();
    });
    dialog.addEventListener('close', function () {
      document.documentElement.style.overflow = previousOverflow;
      if (trigger && trigger.isConnected) trigger.focus({preventScroll: true});
    });
    root.addEventListener('shopify:section:unload', function () {
      if (dialog.open) dialog.close();
      if (observer) observer.disconnect();
    }, {once: true});
  }
  function boot(scope) {
    scope.querySelectorAll('[data-dd-ig]').forEach(init);
  }
  boot(document);
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
})();
